/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

// Store
import { getSubModulesByRoleId } from "../../store";

// Layouts

import PublishedProductionPlan from "./published-production-plan";
import UnpublishedProductionPlan from "./unpublished-production-plan";

import Cookies from "universal-cookie";
const cookies = new Cookies();

const ProductionPlan = ({
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let unpublishedProductionPlanModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "5b97b40b-9a98-4bd7-86e8-494a7c11637b",
  );

  let publishedProductionPlanModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "70f44231-6c66-4011-8033-28634b8df7ad",
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {publishedProductionPlanModule &&
            unpublishedProductionPlanModule ? (
              <TabView>
                <TabPanel header="Unpublished">
                  <UnpublishedProductionPlan />
                </TabPanel>
                <TabPanel header="Published">
                  <PublishedProductionPlan />
                </TabPanel>
              </TabView>
            ) : !publishedProductionPlanModule &&
              unpublishedProductionPlanModule ? (
              <TabView>
                <TabPanel header="Unpublished">
                  <UnpublishedProductionPlan />
                </TabPanel>
              </TabView>
            ) : publishedProductionPlanModule &&
              !unpublishedProductionPlanModule ? (
              <TabView>
                <TabPanel header="Published">
                  <PublishedProductionPlan />
                </TabPanel>
              </TabView>
            ) : (
              <>
                <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                  No Activity Access
                </h4>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(ProductionPlan);
